import { TriStateCheckbox } from "primereact/tristatecheckbox"
import { classNames } from "primereact/utils"
import InputFrame from "./InputFrame"

export default function InputTriStateCheckboxSimpleForm(props) {

    const field = props.controller.field
    const fieldState = props.controller.fieldState
    const border = props.border || false

    // if (typeof field.value === 'number') {
    //     field.value = field.value === 1 ? true : field.value === 0 ? false : null
    // }

    field.value = field.value === true ? true : field.value === false ? false : null

    const onChange = () => {

        const newValue = field.value === true ? false : field.value === false ? null : true

        field.onChange(newValue)

    }

    return (
        <>
            <InputFrame {...props} className="flex">
                <div className={`flex flex-row gap-2 align-items-center ${border ? 'p-inputtext' : 'mt-2'} text-sm`}>
                    <TriStateCheckbox
                        {...field}
                        id={field.name}
                        inputId={field.name}
                        value={field.value}
                        onChange={onChange}
                        onBlur={field.onBlur}
                        name={field.name}
                        autoComplete="off"
                        className={(fieldState.isDirty ? '' : '') + classNames({ 'p-invalid': fieldState.error })}
                        inputMode={props.inputMode}
                        pattern={props.pattern}
                        onKeyDown={props.onKeyDown}
                        disabled={props.disabled}
                        placeholder={props.placeholder}
                    />
                    <span
                        onClick={() => props.disabled || onChange()}
                        style={{
                            cursor: props.disabled ? 'default' : 'pointer',
                            userSelect: 'none',
                            color: props.disabled ? '#ccc' : 'inherit'
                        }}
                    >
                        {props.label}
                    </span>
                </div>

            </InputFrame>
        </>
    )
}
